import { render } from "./tapbar.vue?vue&type=template&id=f85c5c50&scoped=true&ts=true"
import script from "./tapbar.vue?vue&type=script&lang=ts"
export * from "./tapbar.vue?vue&type=script&lang=ts"

import "./tapbar.vue?vue&type=style&index=0&id=f85c5c50&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f85c5c50"]])

export default __exports__